module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAMBAMAAABPbPrXAAAAAXNSR0IB2cksfwAAAB5QTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtyhvagAAAAp0Uk5TADAQYP/QcEDvID6Ak1YAAAAzSURBVHicY2BgYBBigABmRyjDxAAq4IxLQMQFDBwYVN3KQaCAgSlCACqn2ghlIAl1gkgAiUII7UblqpYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/content-view--header--back.png
// module id = 801
// module chunks = 0